/* eslint max-len: 0, no-param-reassign: 0 */
import React from 'react';

import { DEBUG } from '../constants';

export function is_debug() {
    const params = window.location.search.substring(1).split("&")

    let matched = false;
    for (let i=0; i<params.length; i++) {
        if (params[i] === "debug")
            matched = true;
    }

    const activate_debug = matched || DEBUG;

    return activate_debug;
}

export function debug(what) {
    const activate_debug = is_debug();

    return (
        activate_debug &&
        <div>
            <h3>Debug:</h3>
            <pre>{ JSON.stringify(what, null, 2) }</pre>
        </div>
    );
}
